import { dataHooks } from '@wix/data-hooks';

export const headerActionsDataHooks = dataHooks<{
  resetChatButton;
  newMessageNotificationIcon;
  newMessageNotificationCounter: { count: number };
  newMessageCounterBadge;
  closeWidgetIcon;
  maximizeWidgetSizeIcon;
  resetWidgetSizeIcon;
  articleExternalLink;
}>('headerActions');
